import {
  request
} from "./request_v2.js";


export function getGeneInfoData() {
  return request({
    url: '/ascancer/api/geneinfo'
  })
}

/**
 * Browse => Knowledge Page
 *  */
export function getSpliceKnowledge(params) {
  return request({
    // url: '/ascancer/api/sv'
    url: '/ascancer/api/browse/knowledge',
    params
  })
}

// find all distinct gene_name and ensembl_id
export function getAllGeneFromSV() {
  return request({
    url: '/ascancer/api/sv/allgene',
  })
}

// find all distinct cancer_name
export function getAllCancerFromSV() {
  return request({
    url: '/ascancer/api/sv/allcancer',
  })
}

// find all distinct as_type
export function getAllAstypeFromSV() {
  return request({
    url: '/ascancer/api/sv/allastype',
  })
}

// find all distinct pubmed_id
export function getAllPubmedFromSV() {
  return request({
    url: '/ascancer/api/sv/allpubmed',
  })
}

// find all distinct regulatory mechanism
export function getAllRegulatoryMechanismFromSV() {
  return request({
    url: '/ascancer/api/sv/allregulation',
  })
}

// find all distinct biological function
export function getAllBiologicalFunctionFromSV() {
  return request({
    url: '/ascancer/api/sv/allbiofunc',
  })
}

// find all distinct primary site
export function getAllPrimarySiteFromSV() {
  return request({
    url: '/ascancer/api/sv/allsite',
  })
}

// find all distinct cell lines
export function getAllCellLineFromSV() {
  return request({
    url: '/ascancer/api/sv/allcelline',
  })
}

export function getASModelsByGenenamFromKnowledge(genename) {
  return request({
    url: '/ascancer/api/sv/findasmodelbygene',
    params: {
      genename
    }
  })
}

// depressed (outdated)
export function getSpliceVariantMiniData() {
  return request({
    url: '/ascancer/api/sv/mini'
  })
}


/**
 * Browse => Datasets Page
 */
export function getSpliceDatasets(params) {
  return request({
    url: '/ascancer/api/browse/datasets',
    params
  })
}

export function getAllGeneFromSpliceDataset() {
  return request({
    url: '/ascancer/api/dataset/allgene'
  })
}

export function getAllCancerFromSpliceDataset() {
  return request({
    url: '/ascancer/api/dataset/allcancer'
  })
}

export function getAllPrimarySiteFromSpliceDataset() {
  return request({
    url: '/ascancer/api/dataset/allsite'
  })
}

export function getAllProjectFromSpliceDataset() {
  return request({
    url: '/ascancer/api/dataset/allproject'
  })
}

export function getASModelsByGenenameFromDatasets(genename) {
  return request({
    url: '/ascancer/api/dataset/findasmodelbygene',
    params: {
      genename
    }
  })
}

export function getAllProjectByGene(genename) {
  return request({
    url: '/ascancer/api/dataset/findprojectbygene',
    params: {
      genename
    }
  })
}